import React, { useState, useEffect } from 'react';
import { MaskedInput } from 'antd-mask-input';
import { useDispatch, useSelector } from 'react-redux';
import { Input, Form, Row, Divider, Select, Tabs, message } from 'antd';
import UploadArchive from 'components/UploadArchive';
import {
  DrawerEdit,
  ResourceEdit,
  refreshAuthenticatedUser,
  FormItemWrap,
  useAuthContext
} from 'react-structure-admin';
import ResCol from 'components/forms/ResCol';
import AddressV2 from 'components/AddressV2';
import { currentUserCancel, currentUserUpdate } from 'stores/users/userActions';
import { federalTaxNumberValidator } from 'util/validators/index';
import {
  cityNormalizeFromSelect,
  cityNormalizeToSelect
} from 'util/normalizers';
import { FederalTaxNumberInputMask } from 'components';
import ConnectedAppsTab from 'pages/shared/ConnectedAppsTab';

const DATA_TAB = 'data';
export const CONNECTED_APPS_TAB = 'connected-apps';

const CurrentUserEdit = (props) => {
  const { isAdmin } = useAuthContext();
  const { data, loading } = props;
  const dispatch = useDispatch();
  const [allowChangeFederalTaxnumber] = useState(data.federalTaxNumber == null);
  const [state, setState] = useState({});
  const { editingByAdmin = false, initialTab } = useSelector(
    (state) => state.resources.users || {}
  );
  const [activeTab, setActiveTab] = useState(initialTab || DATA_TAB);
  const isOwnAccount = !editingByAdmin;

  const handleBeforeSubmit = (dataSubmit) => {
    return {
      ...dataSubmit,
      address: {
        ...dataSubmit.address,
        city: cityNormalizeFromSelect(dataSubmit.address.city)
      },
      profileImage: state.profileImage
        ? {
            fileName: state.profileImage.fileName,
            type: state.profileImage.type
          }
        : undefined
    };
  };

  useEffect(() => {
    setState({ profileImage: data.profileImage });
  }, [data.profileImage]);

  const handleBeforeBinding = ({ address, ...data }) => {
    address = address || {};
    return {
      ...data,
      address: {
        ...address,
        city: cityNormalizeToSelect(address.city)
      }
    };
  };

  const handleChangeProfileImage = (profileImage) => {
    setState({ ...state, profileImage });
  };

  const onAfterUpdate = (response) => {
    if (!editingByAdmin && response && response.data) {
      const { result } = response.data;
      dispatch(
        refreshAuthenticatedUser({
          name: result.name,
          displayName: result.displayName,
          profileImage: result.profileImage
        })
      );
    }

    handleCancel();
    message.success('Registro salvo com sucesso.');
  };

  const handleSubmit = (data) => {
    const values = handleBeforeSubmit(data);
    dispatch(currentUserUpdate(values, onAfterUpdate));
  };

  const handleCancel = () => {
    dispatch(currentUserCancel());
  };

  const dataFields = (
    <>
      <Row>
        <ResCol span={16}>
          <Row>
            <ResCol span={10}>
              <FormItemWrap
                label="CPF"
                name="federalTaxNumber"
                whitespace
                rules={[{ validator: federalTaxNumberValidator }]}
              >
                <FederalTaxNumberInputMask
                  isLegalPerson={false}
                  disabled={!allowChangeFederalTaxnumber}
                />
              </FormItemWrap>
            </ResCol>

            <ResCol span={14}>
              <FormItemWrap
                label="Nome completo"
                name="name"
                required
                whitespace
              >
                <Input maxLength={100} />
              </FormItemWrap>
            </ResCol>
          </Row>

          <Row>
            <ResCol span={10}>
              <FormItemWrap label="Celular" name="phoneNumber" required>
                <MaskedInput mask="(11) 11111-1111" />
              </FormItemWrap>
            </ResCol>

            <ResCol span={14}>
              <FormItemWrap
                label="E-mail"
                name="email"
                type="email"
                required
                whitespace
              >
                <Input maxLength={50} disabled={!isAdmin()} />
              </FormItemWrap>
            </ResCol>
          </Row>

          <ResCol span={10}>
            <FormItemWrap label="Sexo" name="gender">
              <Select>
                <Select.Option key="male" value="male">
                  Masculino
                </Select.Option>
                <Select.Option key="female" value="female">
                  Feminino
                </Select.Option>
              </Select>
            </FormItemWrap>
          </ResCol>
        </ResCol>

        <ResCol span={8}>
          <FormItemWrap className="gx-upload-profile-image">
            <UploadArchive
              name="profileImageFile"
              resource="users/profile-image"
              srcAttribute="fileName"
              onChange={handleChangeProfileImage}
              onBeforeSubmit={handleBeforeSubmit}
              params={data.id ? { id: data.id } : {}}
              initialValue={
                data.profileImage?.type === 'picture'
                  ? data.profileImage.fileName
                  : null
              }
            />
          </FormItemWrap>
        </ResCol>
      </Row>

      <Divider orientation="left">Endereço</Divider>

      <AddressV2 required={false} />
    </>
  );

  return (
    <DrawerEdit
      {...props}
      data={data}
      saving={loading}
      onSubmit={handleSubmit}
      cancelEdit={handleCancel}
      onAfterUpdate={onAfterUpdate}
      onBeforeBinding={handleBeforeBinding}
      size="md"
      readOnly={isOwnAccount && activeTab === CONNECTED_APPS_TAB}
      title={editingByAdmin ? 'Editar usuário' : 'Minha conta'}
    >
      <Form>
        {isOwnAccount ? (
          <Tabs activeKey={activeTab} onChange={setActiveTab}>
            <Tabs.TabPane tab="Dados pessoais" key={DATA_TAB}>
              {dataFields}
            </Tabs.TabPane>
            <Tabs.TabPane tab="Aplicativos conectados" key={CONNECTED_APPS_TAB}>
              <ConnectedAppsTab />
            </Tabs.TabPane>
          </Tabs>
        ) : (
          dataFields
        )}
      </Form>
    </DrawerEdit>
  );
};
export default ResourceEdit.create(CurrentUserEdit, {
  resource: 'users',
  currentAttr: 'currentUser'
});
